import type { Job } from '@/types/job';

const EMPTY_BRANCHES: string[][] = [[], []];

function normalizeBranch(branch: unknown): string[] {
  if (!Array.isArray(branch)) {
    return [];
  }
  return branch.filter((step): step is string => typeof step === 'string');
}

export function normalizeCareerPathBranches(
  value: Job['career_path'] | undefined | null,
): string[][] {
  if (value == null || value === '') {
    return EMPTY_BRANCHES;
  }

  let paths: unknown = value;
  if (typeof value === 'string') {
    try {
      paths = JSON.parse(value);
    } catch {
      return EMPTY_BRANCHES;
    }
  }

  if (!Array.isArray(paths)) {
    return EMPTY_BRANCHES;
  }

  return [normalizeBranch(paths[0]), normalizeBranch(paths[1])];
}

export function parseCareerPathTree(
  careerPath: Job['career_path'] | undefined,
): string[][] {
  return normalizeCareerPathBranches(careerPath).filter(
    (branch) => branch.length > 0,
  );
}
